import axios from 'axios'
import { getAuthToken } from './auth'

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_DOMAIN,
    responseType: 'json',
    headers: {
        domain: 'coinsauction.moblearn.net',
    },
})

axiosInstance.interceptors.request.use(
    (config) => {
        const token = getAuthToken()
        if (token) {
            config.headers.authorization = 'Bearer ' + token
        }
        return config
    },
    (error) => Promise.reject(error),
)

export default axiosInstance
